export type BillRateShiftTiming = 'upcoming' | 'ongoing' | 'past'

export const BILL_RATE_SHIFT_TIMING_LABEL: Record<BillRateShiftTiming, string> =
  {
    upcoming: 'Upcoming',
    ongoing: 'Ongoing',
    past: 'Past',
  }

export function getBillRateShiftTiming(
  shift: { startsAt: string; endsAt: string },
  now: Date = new Date()
): BillRateShiftTiming {
  if (new Date(shift.startsAt) > now) {
    return 'upcoming'
  }
  if (new Date(shift.endsAt) < now) {
    return 'past'
  }
  return 'ongoing'
}
